var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.510742,
    y: 0.605835,
    width: 58.3942,
    height: 58.3942,
    rx: 4,
    fill: "#ED6B08"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6406 25.9255C26.2817 26.7688 27.2945 27.2458 28.353 27.2029C30.0158 27.2029 31.3647 26.1912 31.3647 24.9445C31.3647 23.6978 30.0158 22.6875 28.353 22.6875C26.6902 22.6875 25.3428 21.6759 25.3428 20.4277C25.3428 19.1795 26.6917 18.1693 28.353 18.1693C29.4115 18.1264 30.4242 18.6033 31.0654 19.4467",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.353 27.2029V28.708",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.353 16.6642V18.1693",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5108 42.9212L48.3356 39.6569V31.9927C48.3356 29.073 42.7882 25.9504 40.6714 24.3285",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4888 33.8817L38.1633 29.6131C37.4203 28.8702 36.2157 28.8702 35.4728 29.6131C34.7298 30.3561 34.7298 31.5607 35.4728 32.3036L40.6304 38.1241V41.7737C40.6304 43.4978 43.0946 46.219 43.0946 46.219",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2918 46.2263H19.6846C18.5765 46.2255 17.6787 45.327 17.6787 44.219V15.3869C17.6787 14.2788 18.5765 13.3804 19.6846 13.3796H38.6627C39.7715 13.3796 40.6706 14.278 40.6714 15.3869V31.6234",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9121 33.0876H23.153C22.5483 33.0876 22.0581 33.5778 22.0581 34.1825V40.7518C22.0581 41.3565 22.5483 41.8467 23.153 41.8467H36.2917",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0581 37.4672H34.1019",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6274 33.0876V41.8467",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice-icon.2bf8226d53935f55b23275cbd62117c5.svg";
export { ForwardRef as ReactComponent };